module.exports = __webpack_public_path__ + "img/1-1.b3e62ccf.png";